<template>
  <div class="custom-grid">
    <el-form-item label :rules="uploadRules">
      <div class="grid">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          list-type="picture-card"
          :on-success="handleImgSuccess"
          :before-upload="beforeAvatarUpload"
          :headers="headers"
          :disabled="imgLoading || disabled"
          :multiple="isMultiple"
          :limit="maxCount"
          :file-list="fileList"
          :on-preview="handlePictureCardPreview"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
        >
          <div v-if="!disabled" class="avatar-uploader-icon">
            <span class="icon-wrap">
              <i v-show="imgLoading" class="el-icon-loading" />
              <i v-show="!imgLoading" class="el-icon-plus" />
            </span>
          </div>
          <div v-else class="avatar-uploader-icon">
            <i class="el-icon-remove-outline" />
          </div>
          <div slot="file" slot-scope="{ file }" class="upload-preview">
            <img v-if="!isPdfUrl(file.url)" class="avatar" :src="file.url">
            <img
              v-else
              class="pdf-thumbnail"
              src="@/assets/icon/pdf.png"
              alt=""
            >
            <span class="el-upload-list__item-actions" @click.stop>
              <span
                class="el-upload-list__item-icon"
                @click.stop="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in" />
              </span>
              <span
                :hidden="parentData.isDetail || disabled"
                class="el-upload-list__item-icon"
                @click.stop="handleRemove(file)"
              >
                <i class="el-icon-delete" />
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <el-image-viewer
        v-show="dialogVisible"
        :initial-index="dialogIndex"
        :on-close="
          () => {
            dialogVisible = false;
          }
        "
        :url-list="propImages.length ? propImages : [dialogImageUrl]"
        style="z-index: 9999"
      />
      <el-dialog
        title="文件预览"
        :visible.sync="webviewDialogVisible"
        width="60%"
        append-to-body
        :close-on-click-modal="true"
      >
        <iframe
          v-if="webviewDialogVisible"
          :src="webviewUrl"
          frameborder="0"
          style="width: 100%; height: 600px;"
        />
      </el-dialog>
    </el-form-item>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "ImgUpload",
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    },
    imgList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isicon: {
      type: Boolean,
      default: false
    },
    required: {
      type: [Boolean, Number],
      default: true
    },
    // 最大上传数量，>1 时启用多图模式
    maxCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      uploadUrl: `${this.BASE_API_URL}ntocc-tps-api/fileUpload`,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogIndex: 0,
      imgLoading: false,
      headers: {
        Authorization: "Bearer ",
        deviceId: "0000000000"
      },
      fileList: [],
      isInit: false,
      webviewDialogVisible: false,
      webviewUrl: ""
    };
  },
  computed: {
    isMultiple() {
      return Number(this.maxCount) > 1;
    },
    // 统一为数组，单图时返回空或单元素数组
    propImages() {
      if (this.isMultiple) {
        if (Array.isArray(this.imgList)) return this.imgList;
        if (typeof this.imgList === "string" && this.imgList)
          return [this.imgList];
        return [];
      } else {
        return this.imgList && this.imgList.length > 0 ? [this.imgList[0]] : [];
      }
    },
    // 校验规则：多图为数组类型，至少一张
    uploadRules() {
      if (!this.required) return [];
      if (this.isMultiple) {
        return [
          {
            type: "array",
            min: 1,
            message: `请上传图片`,
            trigger: "change"
          }
        ];
      } else {
        return [{ required: true, message: `请上传图片`, trigger: "change" }];
      }
    }
  },
  watch: {
    // 监听imgList变化，确保fileList格式正确
    imgList: {
      handler(newVal) {
        console.log("imgList========", newVal);
        if (newVal.length === 0) return;
        console.log("!this.disabled", !this.disabled);
        // if (!this.disabled) return;
        if (this.isInit) return;
        this.isInit = true;
        console.log("===========处理数据======", newVal);
        if (Array.isArray(newVal)) {
          // 确保每个元素都是对象格式，而不是字符串
          this.fileList = newVal.map((item, index) => {
            if (typeof item === "string") {
              return {
                uid: Date.now() + index,
                name: `image-${index}`,
                status: "success",
                url: item,
                response: { data: item }
              };
            }
            return item;
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    isPdfUrl(url) {
      return typeof url === "string" && url.toLowerCase().endsWith(".pdf");
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传${this.maxCount}个文件`);
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        (this.isicon &&
          (file.type === "image/x-icon" || file.type === "image/svg+xml"));
      const isPdf = file.type === "application/pdf";
      const isAllowed = isImage || isPdf;
      const isLtnM2 = file.size >= 1024;
      const maxSizeMb = isPdf ? 50 : 10;
      const isLtnM = file.size / 1024 / 1024 < maxSizeMb;
      if (!isAllowed) {
        this.$message.error(
          this.isicon
            ? "上传文件只能是 JPG,BMP,PNG,icon,GIF 或 PDF 格式!"
            : "上传文件只能是 JPG,BMP,PNG 或 PDF 格式!"
        );
        return false;
      }
      if (!isLtnM2) {
        this.$message.error("上传文件大小不能小于 1K!");
        return false;
      }
      if (!isLtnM) {
        this.$message.error(`上传文件大小不能超过 ${maxSizeMb}MB!`);
        return false;
      }
      if (isAllowed && isLtnM && isLtnM2) {
        // 数量限制：使用 fileList 长度，因为 imgList 可能还未更新
        if (this.isMultiple) {
          const count = this.fileList.length;
          if (count >= this.maxCount) {
            this.$message.warning(`最多上传${this.maxCount}个文件`);
            return false;
          }
        }
        this.imgLoading = true;
        // 获取token值，实时获取
        this.headers.Authorization = "Bearer " + getToken();
      }
      return true;
    },
    // 上传后
    async handleImgSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
        this.imgLoading = false;
        return;
      } else {
        await this.$emit("handleImgSuccess", res.data);
        let newImgList = [];
        if (this.isMultiple) {
          newImgList = Array.isArray(this.imgList) ? [...this.imgList] : [];
          newImgList.push(res.data);
          // 只添加新上传的文件到 fileList，避免重新渲染所有图片
          this.fileList.push({
            uid: file.uid,
            name: file.name,
            status: "success",
            url: res.data,
            response: { data: res.data }
          });
        } else {
          newImgList = [res.data];
          // 单图模式直接替换
          this.fileList = [{
            uid: file.uid,
            name: file.name,
            status: "success",
            url: res.data,
            response: { data: res.data }
          }];
        }
        this.imgLoading = false;
        this.$emit("update:imgList", newImgList);
      }
    },
    // 放大 / 预览
    handlePictureCardPreview(file) {
      let url = file.url;
      console.log("url==========", url);
      if (typeof url === "string") {
        url = url.replace(/^http:\/\//, "https://");
      }
      if (this.isPdfUrl(url)) {
        this.webviewUrl = url;
        this.webviewDialogVisible = true;
      } else {
        this.dialogIndex = file.uid || 0;
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      }
    },
    // 删除
    handleRemove(file) {
      let newImgList = [];
      if (this.isMultiple) {
        newImgList = Array.isArray(this.imgList) ? [...this.imgList] : [];
        const index = newImgList.findIndex(
          img =>
            img === file.url ||
            (typeof img === "object" && img.url === file.url)
        );
        if (index > -1) {
          newImgList.splice(index, 1);
        }
        // 同步更新 fileList
        const fileIndex = this.fileList.findIndex(f => f.uid === file.uid);
        if (fileIndex > -1) {
          this.fileList.splice(fileIndex, 1);
        }
      } else {
        newImgList = [];
        this.fileList = [];
      }
      this.$emit("update:imgList", newImgList);
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  .grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .avatar-uploader {
    position: relative;
    cursor: pointer;
    height: 150px;
    border-radius: 10px;
    overflow: hidden;
    .avatar-uploader-icon {
      font-size: 30px;
      color: #8c939d;
      border-radius: 10px;
      width: 150px;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #c0ccda;
      &:hover {
        border-color: #409eff;
      }
    }
    .upload-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 150px;
    }
    .avatar {
      width: 150px;
      height: 150px;
      display: block;
    }
    .pdf-thumbnail {
      width: 76px;
      height: 90px;
    }
    .el-upload-list__item-actions {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      &:hover {
        opacity: 1;
      }
      .el-upload-list__item-icon {
        cursor: pointer;
        margin: 0 10px;
      }
    }
    // 禁用 Element UI 默认的列表项过渡，减少“闪一下”的感觉
    .el-upload-list__item {
      transition: none !important;
    }
  }
}
.color-red {
  color: #f44336;
  line-height: 30px;
}
</style>
